import { render, staticRenderFns } from "./selectLoginPage.vue?vue&type=template&id=bc574ee0&scoped=true"
import script from "./selectLoginPage.vue?vue&type=script&lang=js"
export * from "./selectLoginPage.vue?vue&type=script&lang=js"
import style0 from "./selectLoginPage.vue?vue&type=style&index=0&id=bc574ee0&prod&lang=scss"
import style1 from "./selectLoginPage.vue?vue&type=style&index=1&id=bc574ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc574ee0",
  null
  
)

export default component.exports